/**
 * React hooks for Review Sessions feature
 */

import { useQuery } from "@tanstack/react-query";
import { getReviewSessions, getFileContent, type ReviewSession } from "@/lib/erp/reviewSessions";

/**
 * Hook to fetch all review sessions
 */
export function useReviewSessions() {
  return useQuery<ReviewSession[]>({
    queryKey: ["review-sessions"],
    queryFn: getReviewSessions,
    staleTime: 5000, // 5 seconds - allows manual refresh
  });
}

/**
 * Hook to fetch content of a specific file
 */
export function useFileContent(sessionId: string | null, filePath: string | null) {
  return useQuery<string>({
    queryKey: ["review-file", sessionId, filePath],
    queryFn: () => getFileContent(sessionId!, filePath!),
    enabled: !!sessionId && !!filePath,
    staleTime: Infinity, // File content doesn't change during session
  });
}

